import React, { useEffect, useState } from "react"; 
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getOfflineGameByID } from "../../../../Services/OffliineGames/offlineGamesServices";
import { toast } from 'react-toastify';
import { getEnvUrl } from "../../../../utils/Api";

const ViewGame = ({ isShow, close, gameID }) => {  
  const handleClose = () => {
    setShow(false);
    close();
  };

  const [show, setShow] = useState(false);
  const [gameName, setGameName] = useState("");
  const [gameData, setGameData] = useState(null);
  const [description, setDescription] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [subjectName, setSubjectName] = useState("");

  const subjects = [
    { id: 1, name: "English" },
    { id: 2, name: "Maths" }
  ];
  
  const categories = [
    { id: 1, name: "Identification", subjectId: 1 },
    { id: 2, name: "Spellings", subjectId: 1 },
    { id: 3, name: "Other", subjectId: 1 },
    { id: 4, name: "Identification", subjectId: 2 },
    { id: 5, name: "Counting", subjectId: 2 },
    { id: 6, name: "Addition", subjectId: 2 },
    { id: 7, name: "Subtraction", subjectId: 2 },
    { id: 8, name: "Other", subjectId: 2 }
  ];
  const getSubjectName = (id) => {
    return subjects.find(subject => subject.id === id)?.name || "N/A";
  };
  const getCategoryName = (id) => {
    return categories.find(category => category.id === id)?.name || "N/A";
  };

  useEffect(() => { 
    setShow(isShow);
    
    const fetchGameDetails = async () => {
      try {
        if (gameID) {
          const response = await getOfflineGameByID(gameID);
          if (response?.status) {
            const game = response.data;
            setGameData(game);
            setGameName(game.name || "N/A");
            setDescription(game.description || "N/A");
            setCategoryName(getCategoryName(game.category_id));
            setSubjectName(getSubjectName(game.subject_id));
          } else {
            toast.error("Failed to fetch game details");
          }
        }
      } catch (error) {
        console.error("Error fetching game details:", error);
        toast.error("Error fetching game details");
      }
    };

    fetchGameDetails();
  }, [isShow, gameID]); 

  return ( 
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <h5 className="modal-title">Offline Game Details</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          <div className="col-12">
            <div className="d-grid" style={{ gridTemplateColumns: "150px 1fr", gap: "10px" }}>
              <label className="form-label"><b>Name :</b></label>
              <span>{gameName}</span>

              <label className="form-label"><b>Description :</b></label>
              <span>{description}</span>

              <label className="form-label"><b>Category :</b></label>
              <span>{categoryName}</span>

              <label className="form-label"><b>Subject :</b></label>
              <span>{subjectName}</span>

              {gameData?.id && (
                <>
                  <label className="form-label"><b>Banner :</b></label>
                  <img src={`${getEnvUrl()}/admin/media/banner/${gameData.bkey}?width=200`} 
                      alt="Banner" 
                      className="img-fluid" 
                      style={{ maxWidth: "200px", height: "auto" }} />

                  <label className="form-label"><b>Thumbnail :</b></label>
                  <img src={`${getEnvUrl()}/admin/media/banner/${gameData.tkey}?width=200`} 
                      alt="Thumbnail" 
                      className="img-fluid" 
                      style={{ maxWidth: "200px", height: "auto" }} />
                </>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewGame;
